var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "d-flex align-baseline" },
    [
      _c(
        "span",
        {
          staticClass: "upload-count-label primary--text font-weight-bold mr-6",
          attrs: { "data-testid": "monthly-upload-label" },
        },
        [_vm._v(_vm._s(_vm.$t("label")))]
      ),
      _vm._v(" "),
      _c("span", { staticClass: "d-inline-flex align-baseline mr-3" }, [
        _c("span", { staticClass: "mr-2" }, [
          _vm._v(_vm._s(_vm.$t("flying_label"))),
        ]),
        _vm._v(" "),
        _c(
          "span",
          {
            staticClass: "upload-count-number font-weight-bold",
            class: _vm.flyingCountColor,
            attrs: { "data-testid": "flying-traps-count" },
          },
          [_vm._v(_vm._s(_vm.sTypeUsage.traps_used))]
        ),
        _vm._v(" "),
        _c(
          "span",
          {
            staticClass:
              "upload-count-denominator primary--text font-weight-bold mx-1",
            attrs: { "data-testid": "flying-separator" },
          },
          [_vm._v("/")]
        ),
        _vm._v(" "),
        _c(
          "span",
          {
            staticClass:
              "upload-count-denominator primary--text font-weight-bold",
            attrs: { "data-testid": "flying-denominator" },
          },
          [_vm._v(_vm._s(_vm.flyingDenominator))]
        ),
      ]),
      _vm._v(" "),
      _vm.featureIsActive("s_type_crawling_pests")
        ? _c("span", { staticClass: "d-inline-flex align-baseline mr-2" }, [
            _c("span", { staticClass: "mr-2" }, [
              _vm._v(_vm._s(_vm.$t("crawling_label"))),
            ]),
            _vm._v(" "),
            _c(
              "span",
              {
                staticClass:
                  "upload-count-number font-weight-bold primary--text",
                attrs: { "data-testid": "crawling-traps-count" },
              },
              [_vm._v(_vm._s(_vm.sTypeUsage.crawling_traps_used))]
            ),
            _vm._v(" "),
            _c(
              "span",
              {
                staticClass:
                  "upload-count-denominator primary--text font-weight-bold mx-1",
                attrs: { "data-testid": "crawling-separator" },
              },
              [_vm._v("/")]
            ),
            _vm._v(" "),
            _c(
              "span",
              {
                staticClass:
                  "upload-count-denominator primary--text font-weight-bold",
                attrs: { "data-testid": "crawling-denominator" },
              },
              [_vm._v(_vm._s(_vm.crawlingDenominator))]
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "v-tooltip",
        {
          attrs: { "min-width": "10", bottom: "" },
          scopedSlots: _vm._u([
            {
              key: "activator",
              fn: function (ref) {
                var on = ref.on
                var attrs = ref.attrs
                return [
                  _c(
                    "v-icon",
                    _vm._g(
                      _vm._b(
                        {
                          attrs: {
                            "data-testid": "plan-status-help-icon",
                            color: "grey",
                          },
                        },
                        "v-icon",
                        attrs,
                        false
                      ),
                      on
                    ),
                    [_vm._v("\n        fa-question-circle-o\n      ")]
                  ),
                ]
              },
            },
          ]),
        },
        [
          _vm._v(" "),
          _c("span", {
            staticClass: "tooltip-content",
            domProps: { innerHTML: _vm._s(_vm.tooltipExplanation) },
          }),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }